export default "__VITE_ASSET__6c652e9b__"